import { apiRequest } from 'js-api-client';

/**
 * Looks up a billing company by document within a purchase.
 *
 * The provider identifies a company by the pair, not by the number alone: the same digits can be
 * registered under more than one document type, so the API rejects a search without
 * `document_type`.
 *
 * @param {string} purchaseToken - Purchase token used to scope the request.
 * @param {string} document - Normalized company document.
 * @param {string} documentType - Purchaser document brand value (e.g. `NIT`).
 * @param {AbortSignal} [signal] - Optional request cancellation signal.
 * @returns {Promise<object>} Provider billing-company response.
 */
export function fetchBillingCompany(purchaseToken, document, documentType, signal) {
  return apiRequest.get(`purchases/${purchaseToken}/billing_companies`, {
    queryParams: { document, document_type: documentType },
    signal,
  });
}

/**
 * Loads the billing-company city catalog for a purchase.
 *
 * @param {string} purchaseToken - Purchase token used to scope the request.
 * @param {AbortSignal} [signal] - Optional request cancellation signal.
 * @returns {Promise<Array<object>>} Provider city catalog.
 */
export function fetchBillingCompanyCities(purchaseToken, signal) {
  return apiRequest.get(`purchases/${purchaseToken}/billing_company_cities`, {
    signal,
  });
}
